import { ensureUiScope } from '../services/api';
import { readNavContext, type NavContext } from './navContext';

type ScopedIncidentsPathOptions = {
  navContext?: NavContext;
  siteId?: string;
  includeDeviceAndCameraContext?: boolean;
};

export function buildScopedIncidentsPath(
  basePath: string = '/incidents',
  options: ScopedIncidentsPathOptions = {},
): string {
  const origin =
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  const url = new URL(basePath, origin);
  if (url.pathname !== '/incidents') {
    return url.pathname + (url.search ? url.search : '');
  }

  const navContext = options.navContext ?? readNavContext();
  const scope = ensureUiScope();
  const siteId = String(options.siteId || navContext.site_id || scope.siteId || '').trim();
  const cameraId = String(navContext.camera_id || '').trim();
  const deviceId = String(navContext.device_id || '').trim();
  const includeDeviceAndCameraContext = Boolean(options.includeDeviceAndCameraContext);

  if (siteId && !url.searchParams.get('site') && !url.searchParams.get('site_id')) {
    url.searchParams.set('site', siteId);
  }
  if (includeDeviceAndCameraContext && cameraId && !url.searchParams.get('camera_id')) {
    url.searchParams.set('camera_id', cameraId);
  }
  if (includeDeviceAndCameraContext && deviceId && !url.searchParams.get('device_id')) {
    url.searchParams.set('device_id', deviceId);
  }

  return url.pathname + (url.search ? url.search : '');
}
